import {t} from '@lingui/macro'
import {useLocation} from 'react-router-dom'

import {useAcademyContext} from '../../components/academy-context/academy-context'

export const useSideOverview = () => {
    const {pathname} = useLocation()
    const {country} = useAcademyContext()
    const activePage = pathname.split('/').slice(-1)[0]

    const overviewSteps = [
        {isActive: activePage === 'introduction', title: t`Introduction (3 mins)`},
        {isActive: activePage === 'employee-experience', title: t`Employee experience (2 mins)`},
        {
            isActive: activePage === 'pleo-for-your-clients',
            title: t`Pleo for your clients (2 mins)`,
        },
    ]

    const getContent = () => {
        // TODO get missing content from Marketing
        switch (country) {
            case 'DE':
            case 'DK':
            case 'GL':
            case 'SE':
            default:
                // default is GB, IE, US
                return {
                    pleoPricingPlansUrl:
                        //TODO Pricing Plans Url provided by Marketing is broken
                        'https://eng9e.seismic.com/ls/7fa51320-2b5e-497a-ae29-d8efea57641a/VrNiy3RHUlDWoLsF#/content/1c698345-12f6-491b-839d-779485885547',
                    videoId: '449k2810qn',
                    whatIsPleoUrl:
                        'https://eng9e.seismic.com/ls/7fa51320-2b5e-497a-ae29-d8efea57641a/VrNiy3RHUlDWoLsF#/content/2fb6c6fd-137e-4de8-b26e-57ff57c30db3',
                }
        }
    }

    const getUsefulMaterials = () => {
        switch (activePage) {
            case 'introduction':
                return [
                    {title: t`What is Pleo?`, url: getContent().whatIsPleoUrl},
                    {title: t`Pleo price plans`, url: getContent().pleoPricingPlansUrl},
                ]
            default:
                return []
        }
    }

    return {overviewSteps, usefulMaterials: getUsefulMaterials()}
}
